import {
  Box,
  Button,
  Drawer,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  IconButton,
} from "@mui/material";

export default function AlertConfirm(props) {
  const { open, handleAlertClose, title, text, action, callback } = props;

  return (
    <Dialog
      open={open}
      onClose={handleAlertClose}
      className="alert-wrap"
      aria-labelledby="alert-dialog-title"
    >
      <DialogTitle className="tit-center" id="alert-dialog-title">
        {title ? title : "알림"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          dangerouslySetInnerHTML={{
            __html: text ? text : "-",
          }}
        />
      </DialogContent>
      <DialogActions className="btn-center">
        <Button
          variant="contained"
          size="small"
          onClick={handleAlertClose}
          style={{ backgroundColor: "#bebebe" }}
        >
          취소
        </Button>
        <Button
          onClick={action}
          autoFocus
          variant="contained"
          color="primary"
          size="small"
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
}
